import React from 'react';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingMessageRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1, 1.5),
  minHeight: 200
}));

const LoadingMessage = props => {
  const { innerRef, ...rest } = props;
  return (
    <LoadingMessageRoot ref={innerRef} data-qa-id="loading-message" {...rest}>
      <CircularProgress size={20} />
    </LoadingMessageRoot>
  );
};

export default LoadingMessage;
